import { useContext } from 'react'

import { MODALS_ID } from '../../../../constants'

import { openAppSettings } from '../../../../utils'

import { ModalContext } from '../../../../provider/ModalProvider'

import { Button } from '../../../../components/button'
import { Modal } from '../../../../components/modal'
import { Text } from '../../../../components/text'

export function DeviceNotifyAllowModal() {
  const { closeModal } = useContext(ModalContext)

  const openDeviceSetting = () => {
    closeModal(MODALS_ID.DEVICE_NOTIFY_ALLOW)
    openAppSettings()
  }

  return (
    <Modal id={MODALS_ID.DEVICE_NOTIFY_ALLOW}>
      <Text size={16} weight={500} lineHeight={24} $textAlign="center">
        기기 알림을 켠 후<br />
        이용이 가능합니다.
      </Text>
      <Modal.Footer>
        <Button type="primary" block={true} onClick={openDeviceSetting}>
          기기 알림 켜기
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
